import CONFIG from "../temp/config";
import {NassauLog} from "./myga-utils";

const jsonResponseHandler = async (response) => {
  if (!response.ok) {
    let message = `HTTP error! status: ${response.status}`;
    try {
      const json = await response.json();
      if (json.message) {
        message = json.message
      }
    } catch (e) {
    }
    NassauLog(`jsonResponseHandler, error: ${message}`);
    throw new Error(message);
  }
  return await response.json();
};

export const getInfoForZip = async (zip) => {

  const url = 'https://maps.googleapis.com/maps/api/geocode/json?address='+zip+' USA&key='+CONFIG.googleMapApiKey;

  let response = await fetch(url, {
    method: 'GET',
    headers: {
    },
  });

  // convert the response to JSON.
  const json = await jsonResponseHandler(response);
  // console.log(`getInfoForZip, json: ${JSON.stringify(json,null,2)}`);

  // check for the data element
  if (!json.results || json.results.length===0) {
    throw new Error('error fetching zipcode data');
  }

  const results = {zip:zip,city:'',state:''};
  if (json.status === 'OK' && json.results[0]) {
    const item = json.results[0];
    NassauLog(`Item we are reading: ${JSON.stringify(item)}`)
    const address_components = item['address_components'];
    results.state = address_components[address_components.length-2]['short_name'];
    results.city = address_components[1]['long_name'];
    // ACCOUNTS FOR MULTIPLE CITIES //
    // if (item['postcode_localities']) {
    //   results.localities = []
    //   item['postcode_localities'].map(city=>{
    //     NassauLog(city)
    //     results.localities.push(city)
    //   })
    // }
  }

  // console.log(`getInfoForZip, results: ${JSON.stringify(results)}`);
  return results;
};

// export const checkStateAndZip = async (state,zip) => {
//   if (state.length>0 && zip.length===5) {
//     try {
//       const zipInfo = await getInfoForZip(zip);
//       if (zipInfo.state===state) {
//         return {
//           status:'OK',
//           city: data.city,
//           state: data.state,
//           zip: zip
//         }
//       }
//     } catch (e) {
//       return {status: 'stateZipCheckError'}
//     }
//   }
//   return {status: 'stateZipInvalid'}
// };
